import styled from 'styled-components';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import FooterSlider from './FooterSlider';
import NotificationBox from './NotificationBox';
import { CustomImage, CustomPopover, CustomModal, Text, useText } from '@src/components';
import bottom from '@src/assets/icons/icon-bottom.svg';
import { useCallback, useEffect, useMemo, useRef, useState, Suspense, lazy } from 'react';
import '@src/styles/dashboard.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedCustomer } from '@src/store/slice/customerSlice';
import CustomerListPopoverContent from './CustomerListPopoverContent';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import iconArrowLeft from '@src/assets/icons/icon-arrow-left.svg';
import iconArrowRight from '@src/assets/icons/icon-arrow-right.svg';
import iconRightNotify from '@src/assets/icons/icon-right-notify.svg';
import iconLeftNotify from '@src/assets/icons/icon-left-notify.svg';
import iconRightSwiper from '@src/assets/icons/icon-right-swiper.svg';
import iconLeftSwiper from '@src/assets/icons/icon-left-swiper.svg';
import getirBanner from '@src/assets/images/dashboard/getir_banner_desc.png';
import getirBannerMobil from '@src/assets/images/dashboard/getir_banner_mobil.png';
import bpPoBanner from '@src/assets/images/dashboard/bp_po_banner.png';
import bpPoButton from '@src/assets/images/dashboard/bp_po_button.png';
import mainBanner from '@src/assets/images/dashboard/main-banner.png';
import mainBannerMobil from '@src/assets/images/dashboard/main-banner-mobil.png';
import { getCurrentFrames } from '@src/store/slice/framesSlice';
import iconBilgiYellow from '@src/assets/icons/icon-bilgi-yellow.svg';
import iconYoutubeRed from '@src/assets/icons/icon-youtube-red.svg';
import iconArrowRightBlack from '@src/assets/icons/icon-arrow-right-black.svg';
import iconMoneys from '@src/assets/icons/icon-moneys-new.svg';
import iconWalletCard from '@src/assets/icons/icon-wallet-card-new.svg';
import iconGasStation from '@src/assets/icons/icon-gas-station-new.svg';
import iconMobile from '@src/assets/icons/icon-mobile-new.svg';
import iconNewCard from '@src/assets/icons/icon-new-card-new.svg';
import iconBalanceTop from '@src/assets/icons/icon-balance-top-new.svg';
import greenTick from '@src/assets/icons/green-tick.svg';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';
import { Loading } from '@src/components/Loading';
import { getFaceValues } from '@src/store/slice/faceValuePopupSlice';
import { getPendingNotificationsDashboard } from '@src/store/slice/notificationDashboardSlice';
import { getPendingNotifications } from '@src/store/slice/notificationSlice';
import { useLanguageChange } from '@src/hooks/useLanguageChange';
import { getUserMenus } from '@src/store/slice/menusSlice';
import { setIsBpCustomer } from '@src/store/slice/authSlice';
import { updateActivationCodeForBP } from '@src/store/slice/vehicleManagementStore/vehicleManagementSlice';
import { Wait } from '@src/utils/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink, useHistory } from 'react-router-dom';
const FaceValuePopup = lazy(() =>
  delayPopup(import('../ticketRestaurant/faceValuePopup/faceValuePopup')),
);
const PeriodicCalculation = lazy(() =>
  delayPopup(import('../ticketRestaurant/faceValuePopup/periodicCalculation')),
);

const NameContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-family: UbuntuRegular, sans-serif;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: right;
    color: #1d2228;
  }

  span.current-user {
    font-size: 16px;
    font-family: UbuntuMedium, sans-serif;
    text-align: left;
  }

  span:nth-child(2) {
    color: #3f4957;
    margin-right: 20px;
  }

  @media (max-width: 992px) {
    display: block;

    margin-bottom: 2px;
    span {
      font-size: 8px;
    }

    span:first-child {
      font-size: 12px;
      text-align: start;
      word-break: break-word;
    }
  }

  @media (min-width: 992px) {
    margin-bottom: 24px;
    margin-top: 24px;
  }
`;

const RightNameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CustomerContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 0 4px;
  padding: 6px 4px 3px 7px;
  border-radius: 3px;
  white-space: nowrap;

  span:first-child {
    font-family: UbuntuRegular, sans-serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: #3f4957;
    white-space: nowrap;
  }

  @media (max-width: 992px) {
    display: block;
    margin: 0;
    span:first-child {
      display: inline-flex;
      align-items: center;
    }
  }
`;

const CustomerListContent = styled(CustomerContent)`
  border: solid 1px rgba(107, 119, 137, 0.6);
  cursor: pointer;
  padding: 5px 4px 5px 13px !important;

  span:first-child {
    font-size: 14px;
    font-family: UbuntuRegular, sans-serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: #3f4957;
    white-space: nowrap;
  }

  @media (max-width: 992px) {
    padding: 4px 4px 5px 13px !important;
    display: flex;
    span:first-child {
      font-size: 12px;
    }
  }
`;

const Line = styled.div`
  @media (max-width: 991.98px) {
    height: 2px;
    border: solid 1px #d5d8de;
    margin-bottom: 15.5px;
  }
`;

const Separator = styled.div`
  margin-left: 13px;
  height: 18px;
  width: 2px;
  background: #c1c1c1;
  display: inline-flex;
  @media (max-width: 991.98px) {
    height: 15px;
    margin-right: 11px;
  }
`;

const Content = styled.div`
  @media (max-width: 992px) {
    padding-bottom: 16px;
  }

  @media (min-width: 992px) {
    padding-bottom: 24px;
  }
`;

const ContentWidgetSmall = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  ${(props) => props.singleItem && 'width: calc(50% - 20px);'}
  @media (min-width: 992px) and (max-width: 1210px) {
    flex-wrap: wrap;
  }
`;

const ContentWidgetSmallMobile = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ContentWidgetMedium = styled.div`
  padding-bottom: 24px;

  @media (min-width: 1568px) {
    > div {
      row-gap: 24px;
      column-gap: 24px;

      > div {
        width: 49%;
      }
    }
  }
  @media (min-width: 1210px) and (max-width: 1567.98px) {
    > div {
      row-gap: 24px;
      column-gap: 24px;

      > div {
        width: 48.5%;
      }
    }
  }
  @media (min-width: 992px) and (max-width: 1210px) {
    > div {
      row-gap: 24px;
      column-gap: 24px;

      > div {
        width: 100%;
      }
    }
  }

  @media (max-width: 992px) {
    > div {
      row-gap: 24px;

      > div {
        width: 100%;
      }
    }
  }
`;

const ContentWidgetLarge = styled.div`
  padding-bottom: 24px;

  > div {
    row-gap: 24px;
  }
`;

const SmallWidget = styled.div`
  height: 180px;
  width: 100% !important;
  margin-bottom: 24px;

  @media (max-width: 992px) {
    width: 100% !important;
  }

  @media (min-width: 992px) {
    width: 254px;
    flex: 1 1 0;
  }
`;

const MiddleWidget = styled.div`
  height: 180px;
  width: 100% !important;
`;

const LargeWidget = styled.div`
  height: 180px;

  @media (min-width: 992px) {
    width: 100%;
  }
`;

const ResponsiveContent = styled.div(
  (props) => `
   @media (max-width: 992px) {
       margin-bottom: ${props?.isMargin && props.isMobilBottom === false ? '0' : '16px'};
   }

  @media (min-width: 992px) {
    margin-left: ${props?.isMargin ? '12px' : '0'};
    margin-right: ${props?.isMarginRight ? '12px' : '0'};
  }
`,
);

const CustomSwiperBtn = styled.div`
  position: absolute;
  right: 10px;
  bottom: 35%;
  column-gap: 7px;
  display: inline-flex;
  z-index: 999;

  img {
    cursor: pointer;
  }

  .swiper-button-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

function getDiv(index, html) {
  return (
    <div className="row m-0">
      <div key={index} className="col-md-6 col-sm-6 p-0 border-1 border-dark">
        <MiddleWidget dangerouslySetInnerHTML={{ __html: getWidgetMarkup(html) }} />
      </div>
    </div>
  );
}

function decodeBase64Utf8(value) {
  const binaryString = atob(value);
  const bytes = Uint8Array.from(binaryString, (char) => char.codePointAt(0) ?? 0);

  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder('utf-8').decode(bytes);
  }

  return decodeURIComponent(
    Array.from(bytes, (byte) => `%${byte.toString(16).padStart(2, '0')}`).join(''),
  );
}

export function getWidgetMarkup(content) {
  if (!content || typeof content !== 'string') {
    return '';
  }

  const trimmedContent = content.trim();

  if (trimmedContent.startsWith('<')) {
    return trimmedContent;
  }

  const toImageMarkup = (value) => {
    return /^data:image\/[a-zA-Z0-9.+-]+;base64,/.test(value)
      ? `<img src="${value}" alt="widget" style="width: 100%; height: 100%; object-fit: contain;" />`
      : null;
  };

  const directImageMarkup = toImageMarkup(trimmedContent);
  if (directImageMarkup) {
    return directImageMarkup;
  }

  try {
    const decodedContent = decodeBase64Utf8(trimmedContent).trim();
    const decodedImageMarkup = toImageMarkup(decodedContent);

    if (decodedImageMarkup) {
      return decodedImageMarkup;
    }

    return decodedContent;
  } catch (error) {
    return trimmedContent;
  }
}

async function delayPopup(promise) {
  await Wait(2700);
  return promise;
}

function DashBoardNameRow({
  isMobil,
  currentUser,
  selectedCustomer,
  customerList,
  handleSelectedCustomer,
  customerSelectVisible,
  setCustomerSelectVisible,
}) {
  return (
    <NameContent>
      {!isMobil && (
        <span className={'current-user'}>
          {Object.keys(currentUser)?.length > 0 && (
            <span className={'current-user'}>
              <Text t="hello" />
              {` ${currentUser?.name} ${currentUser?.surName}, `}
            </span>
          )}
        </span>
      )}
      <RightNameContent>
        <span>{selectedCustomer?.customerName || ''}</span>
        {customerList?.length > 1 ? (
          <CustomPopover
            overlayClassName={'customer-list-popover'}
            placement="bottomRight"
            content={
              <CustomerListPopoverContent
                customerList={customerList}
                selectCustomerChange={handleSelectedCustomer}
                className={'customer-list-popover-content'}
                selectedCustomer={selectedCustomer}
              />
            }
            visible={customerSelectVisible}
            trigger="click"
            onVisibleChange={(value) => {
              setCustomerSelectVisible(value);
            }}
          >
            <CustomerListContent>
              <span>
                <Text t="customerNumber" />
                {selectedCustomer?.customerId || ''}
              </span>
              <CustomImage
                src={bottom}
                style={{ padding: '0px 5px 0 10px', cursor: 'pointer', width: 'fit-content' }}
              />
            </CustomerListContent>
          </CustomPopover>
        ) : (
          <>
            {!isMobil && <Separator />}
            <CustomerContent>
              <span>
                {isMobil && <Separator />}
                <Text t="customerNumber" /> {selectedCustomer?.customerId || ''}
              </span>
            </CustomerContent>
          </>
        )}
      </RightNameContent>
    </NameContent>
  );
}

function DashBoardBigBanner({ isMobil, bannerHtml }) {
  return (
    <Content>
      <div className="row m-0">
        <div className="col-md-12 p-0">
          <FooterSlider>
            <Swiper
              className={isMobil ? 'mobile-swiper-slider-list ' : ''}
              slidesPerView={'auto'}
              navigation={{
                prevEl: '.prevv',
                nextEl: '.nextt',
              }}
              pagination={true}
              spaceBetween={isMobil ? 18 : 50}
            >
              {bannerHtml?.length > 0 ? (
                <ContentWidgetLarge>
                  {bannerHtml?.map((b64, index) => {
                    return (
                      <div className="row m-0" key={index}>
                        <div className="col-md-12 p-0 border-1 border-dark">
                          <LargeWidget dangerouslySetInnerHTML={{ __html: getWidgetMarkup(b64) }} />
                        </div>
                      </div>
                    );
                  })}
                </ContentWidgetLarge>
              ) : (
                isMobil ? (
                  <div>
                    <SwiperSlide className="mobile-swiper-slide">
                      <div style={{ width: '100%', height: '100%' }}>
                        <a
                          href="https://www.edenred.com.tr/ticket-hediye-karti#target1"
                          target="_blank"
                          style={{
                            backgroundColor: 'white',
                            width: '100%',
                            height: '100%',
                            borderRadius: '10px',
                            position: 'relative',
                          }}
                        >
                          <CustomImage
                            style={{
                              maxWidth: '100%',
                              height: '100%',
                            }}
                            src={mainBannerMobil}
                            alt={'banner'}
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  </div>
                ) : (
                  <SwiperSlide>
                    <div style={{ width: '100%', height: '100%' }}>
                      <a
                        href="https://www.edenred.com.tr/ticket-hediye-karti"
                        target="_blank"
                        style={{
                          backgroundColor: 'white',
                          width: '100%',
                          height: '100%',
                          borderRadius: '10px',
                          position: 'relative',
                          border: 'none',
                        }}
                      >
                        <CustomImage
                          style={{
                            width: '100%',
                            height: '100%',
                          }}
                          src={mainBanner}
                          alt="banner"
                        />
                      </a>
                    </div>
                  </SwiperSlide>
                )
              )}
              <div>
                <CustomImage
                  style={{ display: 'none' }}
                  className="prevv prev-btn-slider"
                  src={iconArrowLeft}
                />{' '}
                <CustomImage
                  style={{ display: 'none' }}
                  className=" nextt next-btn-slider"
                  src={iconArrowRight}
                />
              </div>
            </Swiper>
          </FooterSlider>
        </div>
      </div>
    </Content>
  );
}

DashBoardBigBanner.propTypes = {
  isMobil: PropTypes.bool,
  bannerHtml: PropTypes.array,
};

function ApprovalWidgetAndAdsWidget({ isDesktop, approvalProcessWidget, isMobil }) {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 992);
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 992);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      <div
        className={`approval-widget-ads-widget ${isLargeScreen ? 'mx-0' : ''}`}
        style={{
          ...(isDesktop && approvalProcessWidget?.frameList?.length === 0
            ? {
              paddingBottom: '24px',
            }
            : {}),
        }}
      >
        {isDesktop && approvalProcessWidget?.frameList?.length > 0 && (
          <div
            style={
              isDesktop && approvalProcessWidget?.frameList?.length > 0
                ? {
                  width: 'calc(50% - 10px)',
                }
                : {}
            }
            className="col-lg-6 p-0"
          >
            <ContentWidgetSmallMobile>
              {approvalProcessWidget?.frameList?.length > 1 && (
                <Swiper
                  slidesPerView={'auto'}
                  spaceBetween={20}
                  modules={[Navigation]}
                  navigation={{
                    prevEl: `.p-s-v${approvalProcessWidget?.id}`,
                    nextEl: `.n-s-v${approvalProcessWidget?.id}`,
                  }}
                  className={`mySwiper${index}`}
                >
                  {approvalProcessWidget?.frameList?.map((item, index) => {
                    return (
                      <SwiperSlide key={item?.id + index}>
                        <SmallWidget dangerouslySetInnerHTML={{ __html: item?.htmlTr }} />
                        <CustomSwiperBtn>
                          <CustomImage
                            className={`p-s-v${approvalProcessWidget?.id}`}
                            src={iconLeftSwiper}
                          />
                          <CustomImage
                            className={`n-s-v${approvalProcessWidget?.id}`}
                            src={iconRightSwiper}
                          />
                        </CustomSwiperBtn>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              )}
            </ContentWidgetSmallMobile>
          </div>
        )}
        <div
          style={
            isDesktop && approvalProcessWidget?.frameList?.length > 0
              ? {
                width: 'calc(50% - 10px)',
              }
              : {}
          }
          className={classNames({
            'col-md-12 p-0': isDesktop && approvalProcessWidget?.frameList?.length === 0,
            'col-lg-6 p-0': isDesktop && approvalProcessWidget?.frameList?.length > 0,
          })}
        >
          <FooterSlider>
            <Swiper
              className={isMobil ? 'mobile-swiper-slider-list ' : ''}
              slidesPerView={'auto'}
              navigation={{
                prevEl: '.prevv',
                nextEl: '.nextt',
              }}
              pagination={true}
              spaceBetween={isMobil ? 18 : 50}
            >
              {isMobil ? (
                <div>
                  <SwiperSlide className="mobile-swiper-slide">
                    <div style={{ width: '100%', height: '100%' }}>
                      <div
                        style={{
                          backgroundColor: 'white',
                          width: '100%',
                          height: '100%',
                          borderRadius: '10px',
                          position: 'relative',
                        }}
                      >
                        <CustomImage
                          style={{
                            width: '100%',
                            height: '100%',
                          }}
                          src={getirBannerMobil}
                          alt={'banner'}
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                </div>
              ) : (
                <div>
                  <SwiperSlide>
                    <div style={{ width: '100%', height: '100%' }}>
                      <div
                        style={{
                          backgroundColor: 'white',
                          width: '100%',
                          height: '316px',
                          borderRadius: '10px',
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        <CustomImage
                          src={getirBanner}
                          alt={'banner'}
                          style={{
                            width: '100%',
                            height: '316px',
                            objectFit: 'contain',
                          }}
                        />
                      </div>
                    </div>
                  </SwiperSlide>
                </div>
              )}
              <div>
                <CustomImage
                  className="prevv prev-btn-slider"
                  style={{ display: 'none' }}
                  src={iconArrowLeft}
                />
                <CustomImage
                  className=" nextt next-btn-slider"
                  style={{ display: 'none' }}
                  src={iconArrowRight}
                />
              </div>
            </Swiper>
            <a
              href="https://www.youtube.com/playlist?list=PL5G7fs96lXhr82HZeARQeate9g5aC-9Yo"
              target="_blank"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#f72717',
                marginTop: '16px',
                color: '#fff',
                height: '77px',
                borderRadius: '16px',
                padding: '16px 24px',
                boxShadow: '0 8px 16px 4px rgba(16, 26, 119, 0.08)',
              }}
            >
              <div style={{ fontFamily: 'UbuntuMedium' }}>
                <Text t="doYouNeedHelpWithYourTransactions" />
                <br />
                <Text t="youCanWatchOurGuideVideosByClicking" />
              </div>
              <CustomImage style={{ height: '45px', width: '45px' }} src={iconYoutubeRed} />
            </a>
          </FooterSlider>
        </div>
      </div>
      {!isDesktop && (
        <ContentWidgetSmallMobile>
          &nbsp;
          <>
            {approvalProcessWidget?.frameList?.length < 2 &&
              approvalProcessWidget?.frameList[0]?.htmlTr && (
                <SmallWidget
                  key={approvalProcessWidget?.frameList[0]?.htmlTr}
                  dangerouslySetInnerHTML={{ __html: getWidgetMarkup(approvalProcessWidget?.frameList[0]?.htmlTr) }}
                />
              )}
            {approvalProcessWidget?.frameList?.length > 1 && (
              <Swiper
                slidesPerView={'auto'}
                spaceBetween={20}
                modules={[Navigation]}
                navigation={{
                  prevEl: `.p-s-v${approvalProcessWidget?.id}`,
                  nextEl: `.n-s-v${approvalProcessWidget?.id}`,
                }}
                className={`mySwiper${index}`}
              >
                {approvalProcessWidget?.frameList?.map((item, index) => {
                  return (
                    <SwiperSlide key={item?.id}>
                      <SmallWidget dangerouslySetInnerHTML={{ __html: getWidgetMarkup(item?.htmlTr) }} />
                      <CustomSwiperBtn>
                        <CustomImage
                          className={`p-s-v${approvalProcessWidget?.id}`}
                          src={iconLeftSwiper}
                        />
                        <CustomImage
                          className={`n-s-v${approvalProcessWidget?.id}`}
                          src={iconRightSwiper}
                        />
                      </CustomSwiperBtn>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </>
        </ContentWidgetSmallMobile>
      )}
    </>
  );
}

ApprovalWidgetAndAdsWidget.propTypes = {
  isDesktop: PropTypes.bool,
  isMobil: PropTypes.bool,
  approvalProcessWidget: PropTypes.shape({
    id: PropTypes.any,
    frameList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any,
        htmlTr: PropTypes.string,
      }),
    ),
  }),
};

function SmallWidgets({ isDesktop, smallHtmlWithoutApprovalProcess }) {
  return (
    <div>
      {isDesktop && smallHtmlWithoutApprovalProcess?.length > 0 ? (
        <ContentWidgetSmall singleItem={smallHtmlWithoutApprovalProcess?.length === 1}>
          {smallHtmlWithoutApprovalProcess?.map((html, index) => {
            return (
              <>
                {html?.frameList?.length < 2 && html?.frameList[0]?.htmlTr && (
                  <SmallWidget
                    key={html?.frameList[0]?.htmlTr}
                    dangerouslySetInnerHTML={{ __html: getWidgetMarkup(html?.frameList[0]?.htmlTr) }}
                  />
                )}
                {html?.frameList?.length > 1 && (
                  <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={40}
                    modules={[Navigation]}
                    navigation={{
                      prevEl: `.p-s-v${html?.id}`,
                      nextEl: `.n-s-v${html?.id}`,
                    }}
                    className={`mySwiper${index}`}
                  >
                    {html?.frameList?.map((item, index) => {
                      return (
                        <SwiperSlide key={item?.id + index}>
                          {item?.htmlTr && (
                            <SmallWidget dangerouslySetInnerHTML={{ __html: getWidgetMarkup(item?.htmlTr) }} />
                          )}
                          <CustomSwiperBtn>
                            <CustomImage className={`p-s-v${html?.id}`} src={iconLeftSwiper} />
                            <CustomImage className={`n-s-v${html?.id}`} src={iconRightSwiper} />
                          </CustomSwiperBtn>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                )}
              </>
            );
          })}
        </ContentWidgetSmall>
      ) : null}
      {!isDesktop && smallHtmlWithoutApprovalProcess?.length > 0 ? (
        <ContentWidgetSmallMobile>
          {smallHtmlWithoutApprovalProcess?.map((html, index) => (
            <>
              {html?.frameList?.length < 2 && html?.frameList[0]?.htmlTr && (
                <SmallWidget
                  key={html?.frameList[0]?.htmlTr}
                  dangerouslySetInnerHTML={{ __html: getWidgetMarkup(html?.frameList[0]?.htmlTr) }}
                />
              )}
              {html?.frameList?.length > 1 && (
                <Swiper
                  slidesPerView={'auto'}
                  spaceBetween={20}
                  modules={[Navigation]}
                  navigation={{
                    prevEl: `.p-s-v${html?.id}`,
                    nextEl: `.n-s-v${html?.id}`,
                  }}
                  className={`mySwiper${index}`}
                >
                  {html?.frameList?.map((item, index) => {
                    return (
                      <SwiperSlide key={item?.id}>
                        <SmallWidget dangerouslySetInnerHTML={{ __html: getWidgetMarkup(item?.htmlTr) }} />
                        <CustomSwiperBtn>
                          <CustomImage className={`p-s-v${html?.id}`} src={iconLeftSwiper} />
                          <CustomImage className={`n-s-v${html?.id}`} src={iconRightSwiper} />
                        </CustomSwiperBtn>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              )}
            </>
          ))}
        </ContentWidgetSmallMobile>
      ) : null}
    </div>
  );
}

function LargeWidgets({ largeHtml }) {
  return (
    <>
      {largeHtml?.length > 0 ? (
        <ContentWidgetLarge>
          {largeHtml?.map((b64, index) => {
            return (
              <div className="row m-0" key={index}>
                <div className="col-md-12 p-0 border-1 border-dark">
                  <LargeWidget dangerouslySetInnerHTML={{ __html: getWidgetMarkup(b64) }} />
                </div>
              </div>
            );
          })}
        </ContentWidgetLarge>
      ) : null}
    </>
  );
}

LargeWidgets.propTypes = {
  largeHtml: PropTypes.array,
};

function NotificationWidget({
  isDesktop,
  isMobil,
  notificationList,
  pagedProperty,
  page,
  setPage,
}) {
  const notificationIconList = {
    1: { icon: iconWalletCard },
    2: { icon: iconMoneys },
    3: { icon: iconGasStation },
    6: { icon: iconMobile },
    5: { icon: iconNewCard },
    4: { icon: iconBalanceTop },
    7: { icon: iconMoneys },
    8: { icon: iconMoneys },
    9: { icon: iconNewCard },
    10: { icon: iconMobile },
  };
  useEffect(() => {
    if (pagedProperty?.currentPage && pagedProperty?.totalPages) {
      const fractionEl = document.querySelector('.swiper-paginations');
      if (fractionEl) {
        fractionEl.innerHTML = `${pagedProperty?.currentPage}/${pagedProperty?.totalPages}`;
      }
    }
  }, [pagedProperty?.currentPage, pagedProperty?.totalPages]);

  const uniqueNotificationList = useMemo(() => {
    console.log('notificationList', notificationList);
    if (!notificationList) return [];
    const seen = new Set();
    return notificationList.filter((item) => {
      const t = item?.type;
      if (seen.has(t)) return false;
      seen.add(t);
      return true;
    });
  }, [notificationList]);

  return (
    <Content className="notification-widget">
      <div className="row m-0">
        <div className="col-lg-12 p-0">
          <ResponsiveContent
            isMargin={false}
            isMarginRight={false}
            style={!isDesktop && !isMobil ? { marginBottom: '24px' } : {}}
          >
            <NotificationBox>
              <div className="notification-box-content">
                <div className="notification-header">
                  <span>
                    <Text t="notifications" />
                  </span>
                  <div className="pagination-btns">
                    <button
                      onClick={() => pagedProperty.hasPrevious && setPage(page - 1)}
                      style={{ border: 'none', background: 'none' }}
                    >
                      <CustomImage className="prev-notify" src={iconLeftNotify} />
                    </button>
                    <div className="swiper-paginations" />
                    <button
                      onClick={() => pagedProperty.hasNext && setPage(page + 1)}
                      style={{ border: 'none', background: 'none' }}
                    >
                      <CustomImage className="next-notify" src={iconRightNotify} />
                    </button>
                  </div>
                </div>
                <Swiper
                  className="notification-slider"
                  slidesPerView={'auto'}
                  navigation={{
                    prevEl: '.prev-notify',
                    nextEl: '.next-notify',
                  }}
                  pagination={{
                    el: '.swiper-paginations',
                    type: 'fraction',
                    renderFraction: function (currentClass, totalClass) {
                      return (
                        `<span class="${currentClass}"></span>` +
                        '<span>/</span>' +
                        `<span class="${totalClass}"></span>`
                      );
                    },
                  }}
                  spaceBetween={18}
                >
                  <SwiperSlide className="notification-body">
                    {uniqueNotificationList?.length > 0 ? (
                      <>
                        {uniqueNotificationList.map((item, index) => {
                          const notificationData = notificationIconList[item.type];
                          return (
                            <NavLink
                              key={item?.text + index}
                              to={item?.urls}
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                boxShadow: '0 8px 16px 4px rgba(16, 26, 119, 0.08)',
                                borderRadius: '20px',
                                marginBottom: '16px',
                                padding: '12px 10px',
                                height: '68px',
                                overflow: 'hidden',
                                boxSizing: 'border-box',
                              }}
                            >
                              <CustomImage src={notificationData?.icon || ''} />
                              <div
                                style={{
                                  overflow: 'hidden',
                                  maxHeight: '40px',
                                  margin: '0 12px',
                                  fontSize: '16px',
                                  lineHeight: '1.25',
                                  color: '#0f172a',
                                  flex: 1,
                                }}
                              >
                                <span dangerouslySetInnerHTML={{ __html: item?.text }} />
                              </div>
                              <CustomImage
                                style={{
                                  height: '24px',
                                  width: '24px',
                                }}
                                src={iconArrowRightBlack}
                              />
                            </NavLink>
                          );
                        })}
                      </>
                    ) : (
                      <div>
                        <CustomImage
                          style={{ padding: '0px 10px 5px 0', height: '25px' }}
                          src={iconBilgiYellow}
                        />
                        <Text t="youHaveNoNotifications" />
                      </div>
                    )}
                  </SwiperSlide>
                </Swiper>
              </div>
            </NotificationBox>
          </ResponsiveContent>
        </div>
      </div>
    </Content>
  );
}

function MediumWidgets({ mediumHtml }) {
  return (
    <>
      {mediumHtml?.length > 0 ? (
        <ContentWidgetMedium>
          {mediumHtml?.map((html, index) => {
            return getDiv(index, html);
          })}
        </ContentWidgetMedium>
      ) : null}
    </>
  );
}

const Dashboard = () => {
  const isMobil = useMediaQuery({ query: '(max-width: 992px)' });
  const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });
  const { currentUser } = useSelector((state) => state?.user);
  const { customerList, selectedCustomer } = useSelector((state) => state?.customer);
  const { currentFrames } = useSelector((state) => state?.frames);
  const { notificationList, pagedProperty } = useSelector((state) => state?.notifications);
  const { faceValues } = useSelector((state) => state?.faceValuePopup);
  const { isBpCustomer } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const [customerSelectVisible, setCustomerSelectVisible] = useState(false);
  const [modalVisible, handleModalVisible] = useState(true);
  const [largeHtml, setLargeHtml] = useState([]);
  const [mediumHtml, setMediumHtml] = useState([]);
  const [smallHtml, setSmallHtml] = useState([]);
  const [bannerHtml, setBannerHtml] = useState([]);
  const [page, setPage] = useState(1);
  const lastLoadedCustomerIdRef = useRef();
  const history = useHistory();
  const isShownApprovalProcessWidget = useMemo(() => {
    const totalNotify = notificationList?.reduce((acc, cur) => {
      return acc + cur?.value;
    }, 0);
    return totalNotify > 0;
  }, [notificationList, currentFrames]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const loadDashboardData = useCallback(
    async (customerId) => {
      if (!customerId) return;

      const body = {
        customerId,
        userName: currentUser?.userName,
      };
      // DeleteAllCache() kaldırıldı: Frames/getCurrentFrames için 24h TTL cache
      // her dashboard açılışında siliniyor, cache fiilen çalışmıyordu.
      // Mutate eden akışlar (notification action vb.) gerekirse selektif
      // invalidation yapmalı.
      await dispatch(
        getUserMenus({
          customerId,
        }),
      );
      await dispatch(getFaceValues());
      await dispatch(getCurrentFrames(body));
    }, [currentUser?.userName, dispatch],
  );

  useEffect(() => {
    if (
      selectedCustomer?.customerId &&
      lastLoadedCustomerIdRef.current !== selectedCustomer?.customerId
    ) {
      lastLoadedCustomerIdRef.current = selectedCustomer?.customerId;
      loadDashboardData(selectedCustomer?.customerId);
    }
  }, [selectedCustomer?.customerId, loadDashboardData]);

  useEffect(() => {
    const fetchNotifications = async () => {
      await dispatch(
        getUserMenus({
          customerId: selectedCustomer?.customerId,
        }),
      );
      await dispatch(getPendingNotifications({ page, pageSize: 4 }));
    };
    fetchNotifications();
  }, [page, dispatch, selectedCustomer?.customerId]);

  // The widgets, the menu and the pending-notification texts all come from the backend, so the
  // whole dashboard content has to be requested again in the newly selected language. This is the
  // only place that refetches the notifications on a language switch (see useAuthLogic).
  useLanguageChange(() => {
    loadDashboardData(selectedCustomer?.customerId);
    dispatch(getPendingNotifications({ page, pageSize: 4 }));
  });

  useEffect(() => {
    handleAllFrames(currentFrames);
  }, [currentFrames, isShownApprovalProcessWidget]);

  const handleSelectedCustomer = useCallback(
    async (selected) => {
      const customerId = selected?.customerId;
      if (customerId) {
        lastLoadedCustomerIdRef.current = customerId;
      }
      dispatch(setSelectedCustomer(selected));
      setCustomerSelectVisible(false);
      if (customerId) {
        await loadDashboardData(customerId);
      }
    },
    [dispatch, loadDashboardData],
  );
  let smallFrameIndex = 0;
  const processSmallFrame = (frameDetail) => {
    smallFrameIndex++;
    return {
      frameList: frameDetail?.widgetDetail?.filter(
        (widgetDetail) =>
          !([20085, 29].includes(widgetDetail?.id) && !isShownApprovalProcessWidget),
      ),
      id: smallFrameIndex,
      isApprovalWidget: [20085, 29].includes(
        frameDetail?.widgetDetail?.length > 0 ? frameDetail?.widgetDetail[0]?.id : false,
      ),
    };
  };

  const handleAllFrames = (array) => {
    if (!array) return;
    setSmallHtml([]);
    setMediumHtml([]);
    setLargeHtml([]);
    for (const element of array) {
      for (const frameDetail of element?.frameDetail || []) {
        switch (element?.frameType) {
          case 0:
            setSmallHtml((small) => [...small, processSmallFrame(frameDetail)]);
            break;
          case 1:
            setMediumHtml((medium) => [
              ...medium,
              frameDetail?.widgetDetail?.map((widgetDetail) => widgetDetail?.htmlTr),
            ]);
            break;
          case 2:
            setLargeHtml((large) => [
              ...large,
              frameDetail?.widgetDetail?.map((widgetDetail) => widgetDetail?.htmlTr),
            ]);
            break;
          case 3:
            setBannerHtml((banner) => [
              frameDetail?.widgetDetail?.map((widgetDetail) => widgetDetail?.htmlTr),
            ]);
            break;
        }
      }
    }
  };

  const approvalProcessWidget = useMemo(() => {
    return smallHtml?.find((item) => item?.isApprovalWidget);
  }, [smallHtml]);

  const smallHtmlWithoutApprovalProcess = useMemo(() => {
    return smallHtml?.filter((item) => !item?.isApprovalWidget) ?? [];
  }, [smallHtml]);

  return (
    <>
      <DashBoardNameRow
        isMobil={isMobil}
        currentUser={currentUser}
        selectedCustomer={selectedCustomer}
        customerList={customerList}
        handleSelectedCustomer={handleSelectedCustomer}
        customerSelectVisible={customerSelectVisible}
        setCustomerSelectVisible={setCustomerSelectVisible}
      />
      {isMobil && <Line />}
      {/* <SmallWidgets
        isDesktop={isDesktop}
        smallHtmlWithoutApprovalProcess={smallHtmlWithoutApprovalProcess}
      /> */}
      <div className="responsive-flex-container">
        <NotificationWidget
          isDesktop={isDesktop}
          isMobil={isMobil}
          notificationList={notificationList}
          pagedProperty={pagedProperty}
          page={page}
          setPage={setPage}
        />
        <ApprovalWidgetAndAdsWidget
          isDesktop={isDesktop}
          approvalProcessWidget={approvalProcessWidget}
          isMobil={isMobil}
        />
      </div>
      <DashBoardBigBanner isMobil={isMobil} bannerHtml={bannerHtml} />
      <MediumWidgets mediumHtml={mediumHtml} />
      <LargeWidgets largeHtml={largeHtml} />
      {setLoadingState && (
        <Suspense fallback={<Loading />}>
          {faceValues?.htmlType < 9 &&
            !faceValues?.isMainPageAccepted &&
            !(faceValues?.isClosed && faceValues?.isMainPageClosed) &&
            Object.keys(faceValues)?.length > 0 && (
              <FaceValuePopup
                modalVisible={modalVisible}
                handleModalVisible={handleModalVisible}
                faceValues={faceValues}
                isMainPage={true}
              />
            )}
          {faceValues?.htmlType === 9 &&
            !faceValues?.isMainPageAccepted &&
            (!(faceValues?.isClosed && faceValues?.isMainPageClosed) ||
              (faceValues?.isMainPageAccepted === false &&
                faceValues?.isMainPageClosed === true &&
                faceValues?.isClosed === false)) && (
              <PeriodicCalculation
                modalVisible={modalVisible}
                handleModalVisible={handleModalVisible}
                faceValues={faceValues}
                isMainPage={true}
              />
            )}
        </Suspense>
      )}
      <CustomModal
        visible={isBpCustomer}
        maskClosable={false}
        footer={false}
        onCancel={async () => {
          await dispatch(updateActivationCodeForBP({ isMainPageClosed: true }));
          dispatch(setIsBpCustomer(false));
        }}
        className="face-value-popup"
      >
        <div className="face-popup-container">
          <CustomImage style={{ width: '100%', height: '214px' }} src={bpPoBanner} />
          <div className="content">
            <div>
              <b style={{ color: '#f72717' }}>01.03.2025</b> <Text t="asOf" />{' '}
              <b>
                <Text t="yourTicketCarBpContractWillAlsoCover" />
              </b>
            </div>
            <div>
              <br />
              <br />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CustomImage style={{ marginRight: '8px' }} src={greenTick} />
                <b style={{ marginRight: '4px' }}>
                  {' '}
                  <Text t="ticketCarHeader" />
                </b>{' '}
                <Text t="yourTransactionsNow" />{' '}
                <b style={{ marginRight: '4px', marginLeft: '4px' }}>
                  {' '}
                  <Text t="petrolOfisi" />{' '}
                </b>
                <Text t="youWillMakeUnderTheName" />
              </div>
              <br />
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <CustomImage style={{ marginRight: '8px' }} src={greenTick} />
                <div>
                  <b>
                    {' '}
                    <Text t="vehiclesUsingKeyFobs" />{' '}
                  </b>{' '}
                  hem bp’den hem PO’dan mevcut halkaları ile yakıt alabilecekler.
                </div>
              </div>
              <br />
              <div style={{ display: 'flex', alignItems: 'flex-start', color: '#f72717' }}>
                <CustomImage style={{ marginRight: '8px' }} src={greenTick} />
                <div>
                  <b>
                    {' '}
                    <Text t="vehiclesUsingFuelCardsAndKeyFobs" />{' '}
                  </b>{' '}
                  <Text t="theyMustDefinitelyInformTheCashierOfThe" />
                  <br />
                  <br />
                  <Text t="pleaseShareTheseCodesWithYourEmployees" />
                </div>
              </div>
              <br />
              <div style={{ textAlign: 'center' }}>
                <b>
                  <Text t="pleaseClickToReceiveActivationCodes" />
                </b>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CustomImage
                onClick={async () => {
                  await dispatch(updateActivationCodeForBP({ isMainPageAccepted: true }));
                  dispatch(setIsBpCustomer(false));
                  history.push('/ticket-car/vehicle-management');
                }}
                style={{ width: '183px', height: '63px', margin: '20px 0', cursor: 'pointer' }}
                src={bpPoButton}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default Dashboard;

NotificationWidget.propTypes = {
  isDesktop: PropTypes.bool,
  isMobil: PropTypes.bool,
  notificationList: PropTypes.array,
  pagedProperty: PropTypes.object,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
};
